<script setup lang="ts">
import { ElContainer, ElMain } from "element-plus";
import { ref } from "vue";
import TabNav from "@/components/common/TabNav/TabNav.vue";
import { useScreenType } from "@/composables/useScreenType";
import type { TabNavItem } from "./navigation/types";

export interface Props {
  navItems?: Readonly<TabNavItem[]>;
}

defineProps<Props>();

const { isMobile } = useScreenType();

const selectedTabIndex = ref(0);
</script>

<template>
  <el-container
    :class="[
      'main-layout',
      { 'first-tab-selected': navItems?.length && selectedTabIndex === 0 },
    ]"
  >
    <el-container>
      <TabNav
        v-if="navItems?.length && !isMobile"
        :items="navItems"
        type="border-card"
        use-router-mode
        @click="(index: number) => (selectedTabIndex = index)"
      />
      <el-main>
        <slot />
      </el-main>
    </el-container>
  </el-container>
</template>

<style lang="css" scoped>
.so-container {
  flex-direction: column;
}

.main-layout {
  z-index: 0;
  padding-top: var(--navbar-offset);
}

.main-layout.first-tab-selected main {
  border-top-left-radius: 0;
}
</style>
